import { useAppDispatch, useAppState } from '@/store';
import { useEffect, useMemo } from 'react';
import { getFaqs, selectFaqs, selectFaqsIsLoading, selectPagination } from '../feature';
import { GetFaqsDTO } from '@/modules/Faq/dtos';

export const useGetFaqs = (channelId?: number) => {
  const dispatch = useAppDispatch();
  const faqs = useAppState(selectFaqs);
  const isLoading = useAppState(selectFaqsIsLoading);
  const pagination = useAppState(selectPagination);

  useEffect(() => {
    if (!channelId) return;
    const dto = new GetFaqsDTO({ channelId });
    dispatch(getFaqs(dto));
  }, [channelId, dispatch]);

  return useMemo(() => ({ faqs, isLoading, pagination }), [faqs, isLoading, pagination]);
};
